import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { forwardRef } from "react";
import { tv } from "tailwind-variants";
import Icon from "../../icons";
import { cn } from "../../utils";
const customIcon = (icon, position) => {
    return React.cloneElement(icon, {
        className: cn("absolute top-0 bottom-0 m-auto text-gray-10 size-4", position === "start" ? "left-2.5" : "right-1.5"),
    });
};
export const inputVariants = tv({
    base: `
    border-input flex h-9 w-full rounded-md border border-gray-light bg-white px-3 py-1 text-sm 
    placeholder:text-gray-9 focus-visible:outline-none focus-visible:border-black
    file:border-0 file:bg-transparent file:text-sm file:font-medium
    disabled:cursor-not-allowed disabled:bg-gray-2 disabled:border-gray disabled:text-gray
    [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none
  `,
    variants: {
        size: {
            regular: "h-9",
            condensed: "h-8",
        },
        error: {
            true: "border-danger",
            false: "",
        },
        startIcon: {
            true: "pl-8",
            false: "",
        },
        endIcon: {
            true: "pr-8",
            false: "",
        },
        loading: {
            true: "pr-8",
            false: "",
        },
    },
});
const Input = forwardRef(({ className, type, startIcon = false, endIcon = false, loading = false, error = false, size = "regular", disabled = false, ...props }, ref) => {
    return (_jsxs("div", { className: "relative", children: [startIcon ? customIcon(startIcon, "start") : null, _jsx("input", { type: type, className: cn(inputVariants({
                    size,
                    loading,
                    error,
                    startIcon: !!startIcon,
                    endIcon: !!endIcon,
                }), className), disabled: disabled, ref: ref, ...props }), loading ? _jsx(Icon, { name: "cb-loading-spin", className: "absolute top-0 right-3 bottom-0 m-auto size-4 text-primary" }) : null, endIcon ? customIcon(endIcon, "end") : null] }));
});
Input.displayName = "Input";
export default Input;
